import { ReactNode } from 'react'

import { AuthProvider, AuthState } from 'modules/auth/context'

export interface ProvidersState {
  auth?: AuthState
}

export interface Props {
  children: ReactNode,
  state?: ProvidersState
}

const Providers = ({ children, state }: Props) => {
  return (
    <AuthProvider state={state?.auth}>
      {children}
    </AuthProvider>
  )
}

export default Providers
